import { useSelector } from 'react-redux';
import { useRouteLocation } from 'react-router-stack';
import fantasyRedirect from '../../../hoc/fantasy_redirect';

import { isBannedStateForFantasySports, isSmartPhone } from '../../../utilities/helper';
import './index.css';
import FantasyHomeMWeb from './index_mWeb';
import FantasyHomeWeb from './index_Web';

const FantasyHome = () => {
  const { state = {} } = useRouteLocation() as any;
  const { gameType = '' } = state;
  const app = useSelector((state: any) => state.app);
  const { currentLocationState = '' } = app;
  const isBanned = isBannedStateForFantasySports(currentLocationState);

  return (
    <>
      {isSmartPhone ? (
        <FantasyHomeMWeb
          gameType={gameType}
          currentLocationState={currentLocationState}
          isBanned={isBanned}
        />
      ) : (
        <FantasyHomeWeb
          gameType={gameType}
          currentLocationState={currentLocationState}
          isBanned={isBanned}
        />
      )}
    </>
  );
};
export default fantasyRedirect(FantasyHome);
